import { createFlagStore } from '@thyme/libs/src/flags/store'
import { FlagDefinition } from '@thyme/libs/src/flags/types'
import { AppBannerConfig } from '@/tokens/AppBanner/types'

const flagDefinitions = {
  // PERMANENT FLAGS
  showAppBanner: {
    // Example of setting locally to test
    local: undefined, // { message: 'This is a banner', status: 'INCIDENT' },
    fallback: undefined,
  } as FlagDefinition<AppBannerConfig>,
  showMaintenancePage: {
    local: false,
    fallback: false,
  },
  showAskThyme: {
    // Internal-only - Toggle Ask Thyme page and button
    // Permanent until replaced by externally facing feature
    local: true,
    fallback: false,
  },
  // TEMPORARY FLAGS
  // CLEANUP (SPC-2393) - Remove after release
  showRecommendedArticles: {
    local: true,
    fallback: false,
  },
  // CLEANUP (SPC-2559) - Remove after release
  showFeedbackForm: {
    local: true,
    fallback: false,
  },
  // CLEANUP (SPC-2704) - Remove after release
  showCareTeamRedesign: {
    local: true,
    fallback: false,
  },
  // CLEANUP (SPC-2782) - Remove after release
  showSymptomHistory: {
    local: true,
    fallback: false,
  },
  // CLEANUP (SPC-2792) - Remove after release
  showAdditionalArticleFilters: {
    local: true,
    fallback: false,
  },
  // CLEANUP (SPC-2810) - Remove after release
  showCallNotes: {
    local: true,
    fallback: false,
  },
}

export const useFlagStore = createFlagStore(flagDefinitions)
